import { render, staticRenderFns } from "./Promotion_Component.vue?vue&type=template&id=f89fff08&scoped=true"
import script from "./Promotion_Component.vue?vue&type=script&lang=js"
export * from "./Promotion_Component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89fff08",
  null
  
)

export default component.exports